import router from "@/router";

export let WebsiteInfo = function() {
  let hostname;
  let hostname_domain;
  let full_host;
  let domain;
  let lang_letters = "";
  let platform_url;
  let webapi_url;

  full_host = hostname = location.host || location.hostname;
  hostname_domain = domain = full_host.split('.')[2];

  if (domain == "com" || domain == "eu") {
    // let url;
    let arr;
    if (location.href.indexOf("?") > -1) {
      arr = location.href.substr(0, location.href.indexOf("?")).split("/");
    } else {
      arr = location.href.split("/");
    }
    if (typeof arr[3] === "string" && arr[3].length == 2) {
      lang_letters  = arr[3];
      // domain = domain.replace("ar", "ae");
      full_host += "/" + lang_letters;
    }
  }

  if (lang_letters == "") lang_letters = domain.replace(/com|eu/, "en");
  lang_letters = lang_letters.replace("ae", "ar");

  function getPrefix() {
    var rtn = "https://";
    if (location.href.indexOf("//stage") > -1) rtn += "stage";
    else if (window.matchMedia("(max-width: 768px)").matches) rtn += "m-";
    return rtn + "trader";
  }

  return {
    getFullHost: function() {
      return full_host;
    },
    getFullHostWithProtocol: function() {
      return "https://" + full_host;
    },
    getLang: function() {
      return lang_letters;
    },
    getHostname: function() {
      return hostname;
    },
    getHostnameDomain: function() {
      return hostname_domain.replace("eu", "com");
    },
    getDomain: function() {
      return domain;
    },
    getPlatformBaseUrl: function() {
      if (platform_url) return platform_url;

      platform_url = getPrefix();
      platform_url += this.getFullHost().substr(
        this.getFullHost().indexOf(".")
      );
      return platform_url;
    },
    getWebapiUrl: function(resource) {
      if (resource && ['dictionary', 'country', 'webtv/get', 'get-symbols'].find(v => resource.includes(v))) {
          return document.location.origin + '/web-api/';
      }

      if (webapi_url) return webapi_url;
      webapi_url = getPrefix() + ".alvexo.";
      if (["es", "pt","fr","jp"].indexOf(this.getDomain()) > -1) webapi_url += "com";
      else webapi_url += this.getDomain();
      webapi_url += "/web-api/";
      return webapi_url;
    }
  };
};

export function scrollToForm() {
  let formElem = document.getElementById("alvexoPlusForm");
  let headerOffset = document.getElementById("headerBackground").offsetHeight;
  let calcHeight = getElemTopPosition(formElem) - headerOffset;
  window.scrollTo(0, calcHeight);
}

export function getElemTopPosition(element) {
  return window.pageYOffset + element.getBoundingClientRect().top;
}

export function cropLangFromPath(pathWithLang, lang) {
  if (pathWithLang.indexOf("/" + lang) == 0) {
    return pathWithLang.slice(3);
  } else {
    return pathWithLang;
  }
}

export function elementAppearsOnScreen(element) {
  if (element) {
    const distanceToElement =
      element.getBoundingClientRect().top - window.innerHeight;
    return (
      distanceToElement < 0 &&
      distanceToElement > -(element.offsetHeight + window.innerHeight)
    );
  } else {
    return false;
  }
}

export function thankYouRedirect() {
  let redirectPath = location.href + "/thank-you";
  window.location.href = redirectPath;
}

export function visualVideoDuration(duration) {
  let flooredDuration = Math.floor(duration);
  let mins = Math.floor(flooredDuration / 60);
  let secs = flooredDuration % 60;
  if (secs.toString().length === 1) {
    secs = "0" + secs;
  }
  return mins + ":" + secs;
}

//usage instructions:
//1.use the '--fixed-bottom-section-height' css variable in order to locate element relative to the fixed messages section
//2.use ResizeObserver.disconnect() / ResizeObserver.observe() when the using component is destroyed
export function fixedBottomMessagesHeightObserver() {
  const fixedMessagesElem = document.getElementsByClassName(
    "sticky_bottom_wrap"
  )[0];
  document.documentElement.style.setProperty(
    "--fixed-bottom-section-height",
    "0px"
  );

  if (fixedMessagesElem) {
    let outputsize = function() {
      document.documentElement.style.setProperty(
        "--fixed-bottom-section-height",
        fixedMessagesElem.offsetHeight + "px"
      );
    };
    outputsize();
    new ResizeObserver(outputsize).observe(fixedMessagesElem);
  }
}

export function isMobileDevice() {
  return window.matchMedia("(max-width: 768px)").matches;
}

export function getEnvironmentInfo() {
  //TODO: temporarily duplicated from the general.js because its scoped. Yori said he will expose it for useage in later version, then we can delete that copy
  var browserOS = navigator.oscpu != null ? navigator.oscpu : "";
  var OS = "";
  var nAgt = navigator.userAgent;
  var browserName = navigator.appName;
  var nameOffset, verOffset;

  // In Opera 15+, the true version is after "OPR/"
  if ((verOffset = nAgt.indexOf("OPR/")) != -1) browserName = "Opera";
  // In older Opera, the true version is after "Opera" or after "Version"
  else if ((verOffset = nAgt.indexOf("Opera")) != -1) browserName = "Opera";
  // In MSIE, the true version is after "MSIE" in userAgent
  else if ((verOffset = nAgt.indexOf("MSIE")) != -1)
    browserName = "Internet Explorer";
  // In Chrome, the true version is after "Chrome"
  else if ((verOffset = nAgt.indexOf("Chrome")) != -1) browserName = "Chrome";
  // In Safari, the true version is after "Safari" or after "Version"
  else if ((verOffset = nAgt.indexOf("Safari")) != -1) browserName = "Safari";
  // In Firefox, the true version is after "Firefox"
  else if ((verOffset = nAgt.indexOf("Firefox")) != -1) browserName = "Firefox";
  // In most other browsers, "name/version" is at the end of userAgent
  else if (
    (nameOffset = nAgt.lastIndexOf(" ") + 1) <
    (verOffset = nAgt.lastIndexOf("/"))
  ) {
    browserName = nAgt.substring(nameOffset, verOffset);
    if (browserName.toLowerCase() == browserName.toUpperCase())
      browserName = navigator.appName;
  }

  if (browserOS.indexOf("NT 6.1") > -1) OS = "Windows 7";
  else if (browserOS.indexOf("95") > -1) OS = "Windows 95";
  else if (browserOS.indexOf("98") > -1) OS = "Windows 98";
  else if (browserOS.indexOf("2000") > -1 || browserOS.indexOf("NT 5.0") > -1)
    OS = "Windows 2000";
  else if (browserOS.indexOf("XP") > -1 || browserOS.indexOf("NT 5.1") > -1)
    OS = "Windows XP";
  else if (browserOS.indexOf("NT 5.2") > -1) OS = "Windows Server 2003";
  else if (browserOS.indexOf("NT 6.0") > -1) OS = "Windows Vista";
  else if (
    browserOS.indexOf("4.0") > -1 ||
    browserOS.indexOf("WinNT") > -1 ||
    browserOS == "Windows NT"
  )
    OS = "Windows NT 4.0";
  else if (
    browserOS.indexOf("X11") > -1 ||
    navigator.appVersion.indexOf("Linux") != -1
  )
    OS = "Linux";
  else if (browserOS.indexOf("Mac") > -1) OS = "Mac OS";
  else if (browserOS.indexOf("Win16") > -1) OS = "Windows 3.11";
  else if (
    typeof navigator.appVersion == "string" &&
    navigator.appVersion.indexOf("Win") != -1
  )
    OS = "Windows";
  else if (
    typeof navigator.appVersion == "string" &&
    navigator.appVersion.indexOf("Mac") != -1
  )
    OS = "MacOS";
  else if (
    typeof navigator.appVersion == "string" &&
    navigator.appVersion.indexOf("X11") != -1
  )
    OS = "UNIX";
  else OS = browserOS;

  return {
    nt_Browser: browserName,
    nt_Language: navigator.language,
    nt_OperationSystem: OS,
    nt_ScreenResolution:
      screen.width != null && screen.height != null
        ? screen.width + "X" + screen.height
        : ""
  };
}

export function isIOS() {
  return (
    [
      "iPad Simulator",
      "iPhone Simulator",
      "iPod Simulator",
      "iPad",
      "iPhone",
      "iPod"
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  );
}

//due to the usage of webpack.IgnorePlugin (in order to make "chunk-vendor" bundle smaller, we need to load the moment language manually
export function importMomentLang(){
  const currentRouteLang = router.currentRoute.params.lang;
  if(currentRouteLang!=="en"|| currentRouteLang!=="jp"){
    import(
        /* webpackChunkName: "language-file" */
        /* webpackInclude: /(fr|es|pt|ar|it|de)\.js$/ */
        `moment/locale/${currentRouteLang}`);
  }
}
